const setSyncLoadingAction = ({ commit }, payload) => {
  commit('setSyncLoading', payload)
}

export default {
  setSyncLoadingAction,
}
